import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './styles.css';
import { Well } from 'react-bootstrap';
import GrayPanel from '../../components/GrayPanel/GrayPanel';

class ConfirmDelete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: this.props.userData,
      token: this.props.token,
      login: this.props.login,
      msg: null,
    };
  }

  componentDidMount = () => {
    const url = `${process.env.API_URL}/api/v1.0/users/${this.state.login}/deleteUser/${
      this.state.token
    }`;
    // let url = `http://localhost:8000/api/v1.0/users/${this.state.login}/deleteUser/${this.state.token}`;

    fetch(url)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          msg: resp.msg,
        });
        setTimeout(() => {
          location.href = '/logout';
        }, 3000);
      });
  };

  render() {
    return (
      <div>
        <div className={s.delContainer} style={{ display: 'block' }}>
          <div className={s.delTitle}>Usuwanie konta</div>
          <GrayPanel title="Informacja">{this.state.msg}</GrayPanel>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ConfirmDelete);



// WEBPACK FOOTER //
// src/routes/ConfirmDelete/index.js